
import "../../assets/css/layout/ngo/NgoHeader.css";
import { useNavigate } from "react-router-dom";



const NgoHeader = ({ title = 'Welcome ' }) => {
  const navigate = useNavigate();
  return (
    <header className="ngo-header">
      <div className="ngo-header-content">
        <h1 className="ngo-header-title">{title}</h1>
        
        <div className="ngo-header-actions">
          <div className="ngo-notification-container">
            <button
      className="ngo-notification-btn"
      onClick={() => navigate("/ngo/notification")}
    >
      <span className="ngo-notification-icon">🔔</span>
      <span className="ngo-notification-badge">3</span>
    </button>
          </div>

          <button className="ngo-settings-btn"
           onClick={() => navigate("/ngo/setting")}>
            <span className="ngo-settings-icon">⚙️</span>
          </button>

          {/* <div className="ngo-user-profile">
            <div className="ngo-user-avatar">
              <span>👤</span>
            </div>
          </div> */}
          <div
  className="ngo-user-profile"
  onClick={() => navigate("/ngo/profile")}
  style={{ cursor: "pointer" }}
>
  <div className="ngo-user-avatar">
    <span>👤</span>
  </div>
</div>

        </div>
      </div>
    </header>
  );
};

export default NgoHeader;